import Ajax from "Utils/ajax";
export const getAllStaff = (data) => Ajax.post('hr/getAllStaff',data); 
export const getDeductionList = (data) => Ajax.post('account/getDeductionList',data); 
export const getDeduction = (data) => Ajax.post('account/getDeduction',data); 
export const addStaffDeduction = (data) => Ajax.post('account/addStaffDeduction',data); 
export const updateStaffDeduction = (data) => Ajax.post('account/updateStaffDeduction',data);
export const removeStaffDeduction = (data) => Ajax.post('account/removeStaffDeduction',data);
export const getDeductionById = (data) => Ajax.post('account/getDeductionById',data);
